import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.style.cursor = 'grab'
    
    // Store bound methods so they can be properly removed
    this.boundHandlePointerDown = this.handlePointerDown.bind(this)
    this.boundHandlePointerUp = this.handlePointerUp.bind(this)

    // Bind native events to bypass SortableJS interference
    // We must use pointer events because SortableJS intercepts pointerdown,
    // which prevents the browser from ever firing mousedown!
    this.element.addEventListener('pointerdown', this.boundHandlePointerDown)
    this.element.addEventListener('pointerup', this.boundHandlePointerUp)
  }

  disconnect() {
    this.element.removeEventListener('pointerdown', this.boundHandlePointerDown)
    this.element.removeEventListener('pointerup', this.boundHandlePointerUp)
  }

  handlePointerDown(event) {
    this.startX = event.clientX
    this.startY = event.clientY
  }

  handlePointerUp(event) {
    if (this.startX == null || this.startY == null) return

    const dx = Math.abs(event.clientX - this.startX)
    const dy = Math.abs(event.clientY - this.startY)
    
    this.startX = null
    this.startY = null

    // If moved more than 5px, it was a drag
    if (dx > 5 || dy > 5) return

    // Allow native clicks on inner interactables
    if (event.target.closest('button, a, input, textarea, select, label')) return

    const taskLink = this.element.querySelector('a[data-task-link="true"]')
    if (!taskLink) return

    if (taskLink.dataset.turboFrame === "_top") {
      window.location.href = taskLink.href
      return
    }

    // Find the modal turbo frame directly and update its src attribute
    // This is the most reliable way to trigger Turbo programmatically without "isTrusted" errors
    const modalFrame = document.getElementById("modal")
    if (modalFrame) {
      modalFrame.src = taskLink.href
    } else {
      window.location.href = taskLink.href
    }
  }
}
